import React, { useState, useEffect, useMemo, useRef } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaBook,
  FaClipboardList,
} from 'react-icons/fa'
import { Pie, Bar } from 'react-chartjs-2'
import Cookies from 'js-cookie'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from 'chart.js'
import axios from 'axios'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
// import { display } from 'html2canvas/dist/types/css/property-descriptors/display'

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
)

export default function Dashboard() {
  const hasFetchedRef=useRef(false)
  const hasFeesFetchedRef =useRef(false)
  const [instituteName, setInstitutename] = useState()
  const [instituteNameTeacher, setinstituteNameTeacher] = useState()
  const [instituteId, setInstituteId] = useState()
  const [countByCourse, setCountByCourse] = useState([])
  const [dashboardData, setDashboardData] = useState({})
  const [feesByMonths, setFeesByMonths] = useState([])

  // Get institute name and ID from cookies
  useEffect(() => {
    const storedInstituteName = Cookies.get('institute_name')
    const storedInstituteId = Cookies.get('institute_id')

    if (storedInstituteName) {
      console.log('Institute name:', storedInstituteName)
      setInstitutename(storedInstituteName)
    }

    if (storedInstituteId) {
      console.log('Institute ID:', storedInstituteId)
      setInstituteId(storedInstituteId)
    }
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    
    if(!institueId || hasFetchedRef.current) return
    hasFetchedRef.current = true

 
    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/dashboard',
          { headers },
        )

        console.log('Students response: ', response.data.data)

        setDashboardData(response.data.data)
        setCountByCourse(response.data.data.students_by_course || [])
        console.log('Course count data:', response.data.data.students_by_course)

        // setFilteredData(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [instituteId])

     useEffect(()=>{
      const fetchInstituteNameCookie = async ()=>{
        const instituteNameCookie = await ApiEndpoints.getAllInstitutes()
        console.log("instituteNameCookie", instituteNameCookie.data.data)

        const cookieInstituteId = Cookies.get("institute_id")
        console.log("cookieInstituteId", cookieInstituteId)

        const allInstitutesData = instituteNameCookie.data.data

        const matchedInstituteName = allInstitutesData.find((item)=>item.institute_id == cookieInstituteId)

        console.log("matchedInstituteName", matchedInstituteName.name)

        setInstitutename(matchedInstituteName.name)
      }
      fetchInstituteNameCookie()
    },[])

  useEffect(() => {
    if( hasFeesFetchedRef.current) return
    hasFeesFetchedRef.current = true
    const fetchMonthFees = async () => {
      try {
        const response = await ApiEndpoints.getFeesByMonths()

        console.log('Fees by month response: ', response.data.data)

        setFeesByMonths(response.data.data)
      } catch (error) {
        console.error(error.response?.data?.message || 'Something went wrong')
      }
    }
    fetchMonthFees()
  }, [])
  const studentData = {
    labels: ['Active', 'Inactive'],
    datasets: [
      {
        data: dashboardData?.students_by_status
          ? [
              dashboardData.students_by_status.active,
              dashboardData.students_by_status.inactive,
            ]
          : [0, 0],
        backgroundColor: ['#007bff', '#ff6384'],
      },
    ],
  }
  const courseLabels = countByCourse.map((course) => course.course_name)
  const courseData = countByCourse.map((course) => course.total_students)

  // const courseChartData = {
  //   labels: courseLabels,
  //   datasets: [
  //     {
  //       label: 'Total Students',
  //       data: courseData,
  //       backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Add more colors as needed
  //     },
  //   ],
  // }

  const courseChartData = useMemo(() => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
    const courseLabels = countByCourse.map((course) => course.course_name)
    const courseData = countByCourse.map((course) => course.total_students)

    return {
      labels: courseLabels,
      datasets: [
        {
          label: 'Total Students',
          data: courseData,
          backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
        },
      ],
    }
  }, [countByCourse])

  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const getLastSixMonths = () => {
    const months = []
    const now = new Date()
    for (let i = 5; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1) // 1 represents the first day
      const monthName = date.toLocaleString('default', { month: 'short' })

      // .push() method used to add one or more elements to the end of an array.
      months.push(`${monthName} ${date.getFullYear()}`)
    }
    return months
  }

  const labels = getLastSixMonths()

  const feesMap = feesByMonths.reduce((acc, item) => {
    const date = new Date(item.month)
    const key =
      date.toLocaleString('default', { month: 'short' }) +
      ' ' +
      date.getFullYear()
    acc[key] = (acc[key] || 0) + item.amount
    return acc
  }, {})

  // Create data aligned with last 6 months
  const feesDataPoints = labels.map((month) => feesMap[month] || 0)

  const data = {
    labels,
    datasets: [
      {
        label: 'Fees Collected (₹)',
        data: feesDataPoints,
        backgroundColor: '#007bff',
        borderRadius: 5,
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          labels: (context) => `₹ ${context.parse.y.toLocaleString()}`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callbacks: (value) => `₹ ${value}`,
        },
      },
    },
  }
  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-center align-items-center text-white">
          <h2 className="m-0 ">
            {instituteName
              ? `${instituteName} Dashboard`
              : 'Institute Management Dashboard'}
          </h2>
        </div>

        <Container
          fluid
          className="p-0 mt-4"
          style={{ backgroundColor: '', minHeight: '100vh' }}
        >
          <Row>
            <Col md={4}>
              <Card className="text-center shadow-sm border-0">
                <Card.Body>
                  <FaUserGraduate size={40} className="text-primary mb-2" />
                  <Card.Title>Total Students</Card.Title>
                  <Card.Text>
                    Active: {dashboardData?.students_by_status?.active || 0}{' '}
                    <b className="text-primary">||</b> Inactive:{' '}
                    {dashboardData?.students_by_status?.inactive || 0}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="text-center shadow-sm border-0">
                <Card.Body>
                  <FaChalkboardTeacher
                    size={40}
                    className="text-success mb-2"
                  />
                  <Card.Title>Total Teachers</Card.Title>
                  <Card.Text>
                    {dashboardData?.total_teachers || 0} Faculty Members
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="text-center shadow-sm border-0">
                <Card.Body>
                  <FaBook size={40} className="text-warning mb-2" />
                  <Card.Title>Total Courses</Card.Title>
                  <Card.Text>
                    Available: {dashboardData?.total_courses || 0}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={4}>
              <Card className="text-center shadow-sm border-0">
                <Card.Body>
                  <FaChalkboardTeacher size={40} className="text-danger mb-2" />
                  <Card.Title>Total Class</Card.Title>
                  <Card.Text>
                    Active {dashboardData?.total_classes || 0}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="text-center shadow-sm border-0">
                <Card.Body>
                  <FaClipboardList size={40} className="text-info mb-2" />
                  <Card.Title>Total Enquries</Card.Title>
                  <Card.Text>
                    Converted:{' '}
                    {dashboardData?.enquiries_by_status?.converted || 0}{' '}
                    <b className="text-primary">||</b> Pending:{' '}
                    {dashboardData?.enquiries_by_status?.pending || 0}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col xs={12} md={6} className=" mb-4 d-flex justify-content-center">
              <Card className="shadow-sm border-0 w-100">
                <Card.Body>
                  <h5 className="text-center">Student Distribution</h5>
                  <Pie data={studentData} />
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="p-3 shadow-sm border-0 w-100">
                <h5 className="text-center" style={{ letterSpacing: '2px' }}>
                  Fees Collection By Months
                </h5>
                <Bar data={data} options={options} />
              </Card>
            </Col>
          </Row>
          <Row className="d-flex align-items-start justify-content-center mt-4 mb-5">
            <div className="d-flext justify-content-start shadow-sm border-0 w-100">
              <Card.Body>
                <h5 className="text-center ">Total Students By Top Courses</h5>
                {countByCourse.length > 0 ? (
                  <Bar data={courseChartData} />
                ) : (
                  <p className="text-center">No course data available.</p>
                )}
              </Card.Body>
            </div>
          </Row>
        </Container>
      </div>
    </div>
  )
}
